import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => ({
	currencies: data.map((c: string) => ({ label: c, value: c })),
});
